// hooks/usePurchaseTracking.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


interface PurchaseTrackingParams {
  orderId?: string;
  value?: number;
  currency?: string;
  contentName?: string;
  contentIds?: string[];
  checkPath?: boolean; // Optional flag to check path
}

export const usePurchaseTracking = (params: PurchaseTrackingParams) => {
  const { 
    orderId, 
    value = 0, 
    currency = 'XAF', 
    contentName = 'Booking', 
    contentIds = [],
    checkPath = true
  } = params;
  
  const location = useLocation();

   useEffect(() => {
    if (typeof window.fbq !== 'function' || !orderId) return;

    // Skip path checking if checkPath is false
    const shouldTrack = !checkPath || (
      location.pathname.includes('/payment_success') ||
      location.pathname.includes('/payment-done-successfully') ||
      location.pathname.includes('/payment/orange-done-successfully')
    );

    if (shouldTrack) {
      window.fbq('track', 'Purchase', {
        content_ids: contentIds.length ? contentIds : [orderId],
        content_name: contentName,
        currency: currency,
        value: value,
        content_type: 'product',
      });
    }
  }, [location.pathname, orderId, value, currency, contentName, contentIds, checkPath]);
};